import { createSlice } from "@reduxjs/toolkit";

// Load cart from localStorage (if available)
const loadCartFromLocalStorage = () => {
  const cart = localStorage.getItem("cart");
  return cart ? JSON.parse(cart) : [];
};

// Save cart to localStorage
const saveCartToLocalStorage = (cart) => {
  localStorage.setItem("cart", JSON.stringify(cart));
};

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cartItems: loadCartFromLocalStorage(), // Load from localStorage
  },
  reducers: {
    addToCart: (state, action) => {
      const itemIndex = state.cartItems.findIndex(
        (item) => item.id === action.payload.id
      );

      if (itemIndex >= 0) {
        // If item exists, update quantity
        state.cartItems[itemIndex].quantity += 1;
      } else {
        // Add new item with quantity 1
        state.cartItems.push({ ...action.payload, quantity: 1 });
      }

      saveCartToLocalStorage(state.cartItems);
    },
    addToCartWithQuantity: (state, action) => {
      const itemIndex = state.cartItems.findIndex(
        (item) => item.id === action.payload.id
      );

      if (itemIndex >= 0) {
        state.cartItems[itemIndex].quantity += 1;
      } else {
        state.cartItems.push({ ...action.payload.product, quantity: action.payload.quantity });
      }

      saveCartToLocalStorage(state.cartItems);
    },
    removeFromCart: (state, action) => {
      console.log("action.payload" , action.payload)
      state.cartItems = state.cartItems.filter(
        (item) => item.id !== action.payload
      );
      saveCartToLocalStorage(state.cartItems);
    },
    increaseQuantity: (state, action) => {
      const item = state.cartItems.find((item) => item.id === action.payload);
      if (item) {
        item.quantity += 1;
      }
      saveCartToLocalStorage(state.cartItems);
    },
    decreaseQuantity: (state, action) => {
      const itemIndex = state.cartItems.findIndex(
        (item) => item.id === action.payload
      );

      if (itemIndex >= 0) {
        if (state.cartItems[itemIndex].quantity > 1) {
          state.cartItems[itemIndex].quantity -= 1;
        } else {
          // If quantity is 1, remove item from cart
          state.cartItems.splice(itemIndex, 1);
        }
      }
      saveCartToLocalStorage(state.cartItems);
    },
    clearCart: (state) => {
      state.cartItems = [];
      saveCartToLocalStorage(state.cartItems);
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  increaseQuantity,
  decreaseQuantity,
  clearCart,
  addToCartWithQuantity
} = cartSlice.actions;
export default cartSlice.reducer;
